<template>
    <div class="card p-3 mb-4">
      <h5>Agregar Nueva Actividad</h5>
      <form @submit.prevent="submitActividad">
        <!-- Desplegable de Etapa/Evento -->
        <div class="mb-3">
          <label for="etapa_evento" class="form-label">Etapa/Evento</label>
          <select v-model="actividad.etapa_evento_cultivo" class="form-select" id="etapa_evento" required>
            <option value="" disabled>Seleccione una etapa/evento</option>
            <option v-for="evento in eventos" :key="evento.id" :value="evento.nombre_evento">
              {{ evento.nombre_evento }}
            </option>
          </select>
        </div>
  
        <!-- Desplegable de Categoría -->
        <div class="mb-3">
          <label for="categoria_tarea" class="form-label">Categoría</label>
          <select v-model="actividad.categoria_tarea" @change="onCategoriaChange" class="form-select" id="categoria_tarea" required>
            <option value="" disabled>Seleccione una categoría</option>
            <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.nombre">
              {{ categoria.nombre }}
            </option>
          </select>
        </div>
  
        <!-- Desplegable de Nombre de Tarea -->
        <div class="mb-3">
          <label for="nombre_tarea" class="form-label">Nombre de la Tarea</label>
          <select v-model="actividad.nombre_tarea" class="form-select" id="nombre_tarea" required>
            <option value="" disabled>Seleccione una tarea</option>
            <option v-for="unaTarea in nombresTareas" :key="unaTarea.id" :value="unaTarea.nombre">
              {{ unaTarea.nombre }}
            </option>
          </select>
        </div>
  
        <div class="mb-3">
          <label for="descripcion_actividad" class="form-label">Descripción</label>
          <textarea v-model="actividad.descripcion" class="form-control" id="descripcion_actividad" required></textarea>
        </div>
  
        <div class="row">
          <div class="col-md-6">
            <label for="costo_usd" class="form-label">Costo Estimado </label>
            <input type="number" v-model="actividad.costo_estimado_usd" class="form-control" id="costo_usd" required />
          </div>
          <div class="col-md-6">
            <label for="costo_alternativo" class="form-label">Horas de trabajo Estimadas</label>
            <input type="number" v-model="actividad.costo_estimado_moneda_alternativa" class="form-control" id="costo_alternativo" required />
          </div>
        </div>
  
        <div class="mt-3">
          <label for="numero_etapa" class="form-label">Número de Etapa</label>
          <input type="number" v-model="actividad.numero_etapa" class="form-control" id="numero_etapa" min="1" required />
        </div>
  
        <button type="submit" class="btn btn-success mt-3">Agregar Actividad</button>
        <button type="button" class="btn btn-danger mt-3" @click="$emit('cancelar')">Cancelar</button>
      </form>
    </div>
  </template>
  
  <script>

import axios from '@/axios';

  export default {
    name: 'NuevaActividad',
    props: {
      planId: {
        type: Number,
        required: true,
      },
      plan_cultivo: {
        type: Object,
        default: () => ({}),
      },
      eventos: {
        type: Array,
        default: () => [],
      },
      categorias: {
        type: Array,
        default: () => [],
      },
      ultimoNumeroEtapa: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        actividad: {
          etapa_evento_cultivo: '',
          categoria_tarea: '',
          nombre_tarea: '',
          descripcion: '',
          costo_estimado_usd: 0,
          costo_estimado_moneda_alternativa: 0,
          numero_etapa: 1,
        },
        nombresTareas: [],
      };
    },
    methods: {
      onCategoriaChange() {
        const categoriaSeleccionada = this.actividad.categoria_tarea;
        const categoria = this.categorias.find((cat) => cat.nombre === categoriaSeleccionada);
        this.nombresTareas = categoria ? categoria.nombre_tareas : [];
      },
      async submitActividad() {
        try {
          const nuevaActividad = {
            plan_id: parseInt(this.planId),
            etapa_evento_cultivo: this.actividad.etapa_evento_cultivo,
            categoria_tarea: this.actividad.categoria_tarea,
            nombre_tarea: this.actividad.nombre_tarea,
            descripcion: this.actividad.descripcion,
            costo_estimado_usd: parseInt(this.actividad.costo_estimado_usd),
            costo_estimado_moneda_alternativa: parseInt(this.actividad.costo_estimado_moneda_alternativa),
            numero_etapa: parseInt(this.actividad.numero_etapa),
          };
          const response = await axios.post('/api/planes_cultivo_actividades', {
            club_id: parseInt(this.$store.getters.getClubActual.id),
            form: nuevaActividad
          });
          alert('Actividad añadida exitosamente');

          this.resetActividad();


          this.$emit('actividad-agregada', response.data);
        } catch (error) {
          console.error('Error al agregar actividad:', error);

          const errorMessage = error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Error al agregar actividad';
          alert(errorMessage);
        }
      },
      resetActividad() {
        this.actividad = {
          etapa_evento_cultivo: '',
          categoria_tarea: '',
          nombre_tarea: '',
          descripcion: '',
          costo_estimado_usd: 0,
          costo_estimado_moneda_alternativa: 0,
          numero_etapa: 1,
        };
        this.nombresTareas = [];
      },
    },
    mounted() {
      this.actividad.numero_etapa = this.ultimoNumeroEtapa + 1;
    },
  };
  </script>
  
  <style scoped>
  .card {
    background-color: #f9f9f9;
    border-radius: 8px;
  }
  </style>
  